import { LayoutType } from "common/form/fields/layoutField/LayoutField";
import styled from "styled-components";

export const GridCont = styled.div`
	display: grid;
	display: -ms-grid;

	min-height: ${(props: any) => props.fullHeight ? "100vh" : "auto"};

	${(props: any) => LayoutType.COLUMN === props.type && `
		grid-template-columns: ${props.units.join(" ")};
		-ms-grid-columns: ${props.units.join(" ")};
	`}

	${(props: any) => LayoutType.ROW === props.type && `
		grid-template-rows: ${props.units.join(" ")};
		-ms-grid-rows: ${props.units.join(" ")};
	`}

	${(props: any) => props.breakPoint !== undefined && `
		@media (max-width: ${props.breakPoint}) {
			display: block;
		}
	`}
`;



// WEBPACK FOOTER //
// ./src/panels/layout/Grid.tsx